import {ProgressChartType} from "./progress-chart"
import InsightDataHelper from "../insight/insight-data-helper"
import {ChartScopeSettings} from "../insight/chart-scope-settings/chart-scope-settings"
import React, {useContext} from "react"
import {ProgressChartArea} from "./progress-chart-area"
import {CategoryHelperContext} from "../../../services/helpers/category-helper"
import {Panel} from "../../../components-shared/panel/panel"
import {SelectedCategoryPill} from "../insight/selected-item-pill/selected-category-pill"
import styles from "./progress-chart.module.scss"
import {Heading} from "../../../components-shared/heading/heading"
import {gaSendDashboardEvent} from "../../../services/analytics/google-analytics-helper"

export interface DashboardProgressChartAreaProps {
  title: string
  type: ProgressChartType
  spendingData: InsightDataHelper
  showCo2: boolean
  chartScopeSettings: ChartScopeSettings
  setChartScopeSettings: (chartScopeSettings: ChartScopeSettings) => void
  selectedCategoryId: number | null
  setSelectedCategoryId: (categoryId: number | null) => void
  setTransactionsCategoryId: (categoryId?: number) => void
  className?: string
}

export const DashboardProgressChartArea : React.FC<DashboardProgressChartAreaProps> = ({title, type, spendingData, showCo2, selectedCategoryId, setSelectedCategoryId, chartScopeSettings, setChartScopeSettings, setTransactionsCategoryId, className}) => {
  const categoryHelper = useContext(CategoryHelperContext)
  if (!categoryHelper) return null

  const clickProgressCategoryMonth = (categoryId: number | undefined, monthIndex: number) => {
    if (spendingData === null || categoryHelper === null) return
    setChartScopeSettings({range: {monthStart: new Date(spendingData.monthlySpendingData.months[monthIndex].month)}, period: "month"})
    if (categoryId !== undefined && categoryHelper.categoriesById[categoryId].parentId === undefined) {
      setSelectedCategoryId(categoryId)
    }
    setTransactionsCategoryId(categoryId)
    gaSendDashboardEvent("Progress chart select month")
  }

  const unselectCategory = () => {
    setSelectedCategoryId(null)
    setTransactionsCategoryId(undefined)
    setChartScopeSettings({...chartScopeSettings})
    gaSendDashboardEvent("Progress chart unselect category")
  }

  return <Panel className={className} fullWidth>
    <div className={styles.TitleAlignContainer}>
      <Heading size="small">
        {title}
        {selectedCategoryId && unselectCategory && <span style={{"marginLeft": "10px"}}><SelectedCategoryPill id={selectedCategoryId} onClick={unselectCategory}/></span>}
      </Heading>
    </div>
    <ProgressChartArea type={type} spendingData={spendingData} showCo2={showCo2} clickCategoryMonth={clickProgressCategoryMonth} selectedProgressCategoryId={selectedCategoryId} />
  </Panel>
}